(function () {
  'use strict';
  if (window.wvrEcommerceEventsInstalled) return;
  window.wvrEcommerceEventsInstalled = true;
  function track(name, properties) {
    try {
      var context = document.querySelector('[data-wvr-funnel-context]');
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || !privacy.analyticsProcessingAllowed()) {
        if (context) context.dataset.analyticsState = privacy ? 'consent-blocked' : 'privacy-loading';
        return;
      }
      if (!window.posthog || typeof window.posthog.capture !== 'function') {
        if (context) context.dataset.analyticsState = 'sdk-unavailable';
        return;
      }
      window.posthog.capture(name, Object.assign({
        instrumentation_version: '2026-09-15',
        page_path: location.pathname,
        market_country: context && context.dataset.country,
        currency: context && context.dataset.currency,
        product_id: context && context.dataset.productId
      }, properties));
      if (context) context.dataset.analyticsState = 'captured';
      return true;
    } catch (_) { /* Analytics must never interrupt shopping. */ }
  }
  function cardProperties(card) {
    return { package_handle: card.dataset.wvrPackage, product_id: card.dataset.productId,
      variant_id: card.dataset.variantId, value: Number(card.dataset.price), currency: card.dataset.currency,
      placement: card.closest('[data-wvr-package-list]').dataset.wvrPackageList };
  }
  var viewedCards = new WeakSet();
  var observer;
  function observeCards() {
    if (!window.IntersectionObserver) return;
    if (observer) observer.disconnect();
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          if (track('wvr_package_view', cardProperties(entry.target))) {
            viewedCards.add(entry.target);
            observer.unobserve(entry.target);
          }
        }
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('[data-wvr-package]').forEach(function (card) { if (!viewedCards.has(card)) observer.observe(card); });
  }
  document.addEventListener('visitorConsentCollected', observeCards);
  if (window.Shopify && !window.Shopify.customerPrivacy && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error) observeCards();
    });
  }
  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    var link = target.closest('[data-wvr-package] a');
    if (link) track('wvr_package_select', cardProperties(link.closest('[data-wvr-package]')));
    var checkout = target.closest('a[href*="/checkout"],button[name="checkout"],input[name="checkout"],.upez-checkout-button,.js-cart-drawer-submit-btn');
    if (checkout) track('wvr_checkout_click', { surface: 'storefront' });
  }, true);
  // Observe successful server responses, not just clicks. Read only IDs and quantities.
  var originalFetch = window.fetch;
  window.fetch = function () {
    var args = arguments, url;
    try { url = new URL(typeof args[0] === 'string' ? args[0] : args[0].url, location.origin); } catch (_) {}
    var request = originalFetch.apply(this, args);
    if (url && url.origin === location.origin && /\/cart\/add(?:\.js)?$/.test(url.pathname)) {
      request.then(function (response) {
        response.clone().json().then(function (data) {
          if (!response.ok || data.status) {
            track('wvr_cart_add_error', { status_code: response.status });
            return;
          }
          var lines = data.items || [data];
          track('wvr_cart_add_success', { items: lines.map(function (line) {
            return { variant_id: String(line.variant_id || line.id || ''), product_id: String(line.product_id || ''), quantity: line.quantity };
          }) });
        }).catch(function () {});
      }).catch(function () { track('wvr_cart_add_error', { status_code: 'network' }); });
    }
    return request;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeCards);
  else observeCards();
})();
